import { render, staticRenderFns } from "./CrudResourcesTable.vue?vue&type=template&id=910c01da&"
import script from "./CrudResourcesTable.vue?vue&type=script&lang=js&"
export * from "./CrudResourcesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports